module.exports = __webpack_public_path__ + "static/mopz-extraimg2@2x-min-ac728fd228c3bcf8036e28696bf8096a.png";